import { render, staticRenderFns } from "./Pagelet.vue?vue&type=template&id=2db69b63&lang=pug"
import script from "./Pagelet.vue?vue&type=script&lang=js"
export * from "./Pagelet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports